import React from "react";
import classes from "./TabPanel.module.css";
const TabPanel = (props) => {
  const { component, componentParams = null } = props;
  return (
    <div className={classes["panel"]}>
      {component && component(componentParams)}
    </div>
  );
};

export default TabPanel;
